import React from 'react';
import pluralize from 'pluralize';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation';
import {observer} from 'mobx-react';

@observer
class DonateFormIhoHonoree extends React.Component {
  handleRemovalClick = () => {
    store.iho.removeHonoree();
    store.donateForm.step = 'amount';
  };

  handleEditMonthSelectionClick = () => {
    store.iho.tab = 'month-selection';
    store.iho.modalOpen = true;
  }

  render() {
    if(!store.iho.honoreeInfoIsPresent || !store.donateForm.acceptsIho) return null;

    const {
      honoreeFullName,
      recipientEmail,
      recipientFullName,
      sendTo,
      type,
    } = store.iho.honoree;

    return (
      <div className='iho'>
        <div className='honoree'>
          <div className='heart mt-1'>
            <i className='cw-icon-heart' />
          </div>
          <div className='details'>
            <h3 className='h60'>
              {store.iho.isSpringIho ?
                <>
                  <a
                    onClick={this.handleEditMonthSelectionClick}
                  >
                    {pluralize('month', store.iho.giftDuration, true)}
                  </a>
                  {' for '}
                </> : (
                'For '
              )}

              <a
                onClick={() => store.iho.modalOpen = true}
              >
                {honoreeFullName}
              </a>
            </h3>
            <p
              className='em'
              dangerouslySetInnerHTML={{__html: t(`views.donate_form.iho.${type}.added`, {name: (sendTo === 'honoree' ? honoreeFullName : recipientFullName), email: recipientEmail})}}
            />
          </div>
          <div className='actions'>
            <a
              className='cw-icon-pencil'
              onClick={() => store.iho.modalOpen = true}
            />
            <i
              className='cw-icon-remove'
              onClick={this.handleRemovalClick}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DonateFormIhoHonoree;
